import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Loading } from '../../components';
import * as configProvider from '../../services/ConfigProvider';
import {
  eventABActivationTest,
  eventLoginSuccess,
  GoogleAnalyticsConstants,
  pushPageViewDataLayer,
} from '../../services/googleTagManager';
import { refreshTokenLogin } from '../../services/Login';
import redirectHistory from '../../utils/redirect';
import useTranslation from '../../utils/translation';
import LoginManual from '../LoginManual';
import LoginSocial from '../LoginSocial';
import styles from './styles.module.css';

const Login = () => {
  const config = configProvider.useConfig();
  const COUNTRY = configProvider.configGetCountry(config);
  const API_URL = configProvider.configGetLoginAdapterUrl(config);
  const localRedirect = configProvider.configGetAliceHost(config);
  const translate = useTranslation(COUNTRY);
  const [autoLogging, setAutoLogging] = useState(false);

  const navigate = useNavigate();

  const handleCreateAccount = () => {
    const params = new URLSearchParams(window.location.search);
    const urlRedirect = params.get('returnUrl');

    let createUrl = '/create';
    if (urlRedirect != null && urlRedirect != '') {
      createUrl = createUrl + '?returnUrl=' + encodeURIComponent(urlRedirect);
    }
    navigate(createUrl);
  };

  useEffect(() => {
    pushPageViewDataLayer('authentication - login', 'logged out');
    eventABActivationTest(GoogleAnalyticsConstants.LOGIN_SCREEN_VIEW);
  }, []);

  useEffect(() => {
    if (!API_URL) return;
    const autoLogin = async () => {
      setAutoLogging(true);
      const result = await refreshTokenLogin(API_URL);
      if (result) {
        eventLoginSuccess('refresh_token');
        redirectHistory(`${localRedirect}`, result.access_token);
      }
      setAutoLogging(false);
    };
    autoLogin();
  }, [API_URL, localRedirect]);

  if (autoLogging) {
    return <Loading visibled={true} />;
  }

  return (
    <div className={styles.socialLogin}>
      <Button
        id={styles.createAccount}
        text={translate['login-manual-button-create-account']}
        type="button"
        onClick={handleCreateAccount}
      />

      <LoginSocial />

      <div className={styles.loginDivider}>
        <span className={styles.textLoginDivider}>ou</span>
      </div>

      <LoginManual />
    </div>
  );
};

export default Login;
